import {
  AfterContentChecked,
  AfterContentInit, AfterViewChecked,
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2
} from '@angular/core';
import { IArea, getRegionAndRect } from './utils';
import { DraggableElementDirective } from './draggable-element.directive';

@Directive({
    selector: '[resizableElement]',
    standalone: false
})
export class ResizableElementDirective implements  AfterViewInit {
  @Input() handlerSize = 10;
  // @Input() ngxBoundsContainerSelector: string | null = null;
  @Input() container: Element | null = null;
  @Input() enable = true;

  @Output() ngxResizeStart: EventEmitter<void> = new EventEmitter<void>();
  @Output() ngxResizing: EventEmitter<void> = new EventEmitter<void>();
  @Output() ngxResizeEnd: EventEmitter<void> = new EventEmitter<void>();

  private mousePosition: { x: number; y: number } = { x: 0, y: 0 };
  private currentResizingHandler: any;

  constructor(private elRef: ElementRef<HTMLElement>,
              private draggableDirective: DraggableElementDirective,
              private renderer2: Renderer2) {
    if (this.elRef.nativeElement.parentElement) {
      const parentStyle = window.getComputedStyle(this.elRef.nativeElement.parentElement);
      if (
        (parentStyle.alignItems && parentStyle.alignItems !== 'normal') ||
        (parentStyle.justifyContent && parentStyle.justifyContent !== 'normal')
      ) {
        this.renderer2.setStyle(this.elRef.nativeElement.parentElement, 'alignItems', 'unset');
        this.renderer2.setStyle(this.elRef.nativeElement.parentElement, 'justifyContent', 'unset');
      }
    }

    if (
      elRef?.nativeElement?.style?.position !== 'absolute' &&
      elRef?.nativeElement?.style?.position !== 'relative' &&
      elRef?.nativeElement?.style?.position !== 'fixed'
    ) {
      console.warn(
        'Element set to position: relative to position resize Handlers. A resizable Element should be positioned absolute or relative'
      );
      this.renderer2.setStyle(this.elRef.nativeElement, 'position', 'relative');
    }

    const handlers: HTMLDivElement[] = [];

    const resizeHandleTypes = ['TopLeft', 'Top', 'TopRight', 'Right', 'BottomRight', 'Bottom', 'BottomLeft', 'Left'];
    for (let i = 0; i < resizeHandleTypes.length; i++) {
      const handle = document.createElement('div') as HTMLDivElement;
      this.renderer2.setStyle(
        handle,
        'width',
        i === 1 || i === 5 ? `calc(100% - ${this.asPxString(this.handlerSize)})` : this.asPxString(this.handlerSize)
      );
      this.renderer2.setStyle(
        handle,
        'height',
        i === 3 || i === 7 ? `calc(100% - ${this.asPxString(this.handlerSize)})` : this.asPxString(this.handlerSize)
      );
      handle.id = `resizableElementResizeHandler${resizeHandleTypes[i]}`;
      handle.classList.add('resizableElementResizeHandler');
      handlers.push(handle);
    }

    for (let i = 0; i < handlers.length; i++) {
      const handler = handlers[i];
      // console.log(i, handler.id);
      this.renderer2.appendChild(elRef.nativeElement, handler);

      this.renderer2.setStyle(handler, 'z-index', 10);
      this.renderer2.setStyle(handler, 'position', 'absolute');
      switch (handler.id) {
        case 'resizableElementResizeHandlerTopLeft':
          this.renderer2.setStyle(handler, 'cursor', 'nw-resize');
          // this.renderer2.setStyle(handler, 'background-color', 'green');
          this.renderer2.setStyle(handler, 'left', this.asPxString(-this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'top', this.asPxString(-this.handlerSize / 2));
          break;
        case 'resizableElementResizeHandlerTop':
          this.renderer2.setStyle(handler, 'cursor', 'n-resize');
          // this.renderer2.setStyle(handler, 'background-color', 'lightgreen');
          this.renderer2.setStyle(handler, 'left', this.asPxString(this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'right', this.asPxString(this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'top', this.asPxString(-this.handlerSize / 2));
          break;
        case 'resizableElementResizeHandlerTopRight':
          this.renderer2.setStyle(handler, 'cursor', 'ne-resize');
          // this.renderer2.setStyle(handler, 'background-color', 'red');
          this.renderer2.setStyle(handler, 'right', this.asPxString(-this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'top', this.asPxString(-this.handlerSize / 2));
          break;
        case 'resizableElementResizeHandlerRight':
          this.renderer2.setStyle(handler, 'cursor', 'e-resize');
          // this.renderer2.setStyle(handler, 'background-color', 'pink');
          this.renderer2.setStyle(handler, 'top', this.asPxString(this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'bottom', this.asPxString(this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'right', this.asPxString(-this.handlerSize / 2));
          break;
        case 'resizableElementResizeHandlerBottomRight':
          this.renderer2.setStyle(handler, 'cursor', 'se-resize');
          // this.renderer2.setStyle(handler, 'background-color', 'darkblue');
          this.renderer2.setStyle(handler, 'right', this.asPxString(-this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'bottom', this.asPxString(-this.handlerSize / 2));
          break;
        case 'resizableElementResizeHandlerBottom':
          this.renderer2.setStyle(handler, 'cursor', 's-resize');
          // this.renderer2.setStyle(handler, 'background-color', 'black');
          this.renderer2.setStyle(handler, 'right', this.asPxString(this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'left', this.asPxString(this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'bottom', this.asPxString(-this.handlerSize / 2));
          break;
        case 'resizableElementResizeHandlerBottomLeft':
          this.renderer2.setStyle(handler, 'cursor', 'sw-resize');
          // this.renderer2.setStyle(handler, 'background-color', 'orange');
          this.renderer2.setStyle(handler, 'left', this.asPxString(-this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'bottom', this.asPxString(-this.handlerSize / 2));
          break;
        case 'resizableElementResizeHandlerLeft':
          this.renderer2.setStyle(handler, 'cursor', 'w-resize');
          // this.renderer2.setStyle(handler, 'background-color', 'yellow');
          this.renderer2.setStyle(handler, 'top', this.asPxString(this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'bottom', this.asPxString(this.handlerSize / 2));
          this.renderer2.setStyle(handler, 'left', this.asPxString(-this.handlerSize / 2));

          break;
        default:
          break;
      }
      handler.addEventListener('mousedown', (ev: MouseEvent) => {
        if (!this.draggableDirective._enable) {
          return;
        }
        this.currentResizingHandler = handler;
        const r = getRegionAndRect(this.container!, this.elRef.nativeElement);
        // console.log('ngxResizeStart', r);
        this.ngxResizeStart.emit();
        this.draggableDirective.regionChange.emit(r.region2);
        ev.stopPropagation();
      });
    }
  }


  ngAfterViewInit(): void {
    // @ts-ignore
    // console.log('[resize] ngAfterViewInit', this.container);
    // this.container =
    //   typeof this.ngxBoundsContainerSelector === 'string'
    //     ? document.querySelector(this.ngxBoundsContainerSelector)
    //     : document.body;

  }




  @HostListener('window:mousemove', ['$event']) onMouseMove(event: MouseEvent) {
    if (this.currentResizingHandler && this.mousePosition) {
      this.unFocus();
      event.preventDefault();
      event.cancelBubble = true;
      const xDiff = event.clientX - this.mousePosition.x;
      const yDiff = event.clientY - this.mousePosition.y;
      let style = window.getComputedStyle(this.elRef.nativeElement);
      let matrix = new DOMMatrixReadOnly(style.transform);
      let oldX = matrix.m41;
      let oldY = matrix.m42;

      // let container;
      //
      // if (typeof this.ngxBoundsContainerSelector === 'string') {
      //   container = document.querySelector(this.ngxBoundsContainerSelector);
      //   if (!container) {
      //     console.warn(`Bounding Element not found with selector ${this.ngxBoundsContainerSelector} \n
      //     Check your input and DOM for the Element`);
      //   }
      // }

      switch (this.currentResizingHandler.id) {
        case 'resizableElementResizeHandlerTopLeft':
          this.resizeLeft(oldX, oldY, xDiff);
          style = window.getComputedStyle(this.elRef.nativeElement);
          matrix = new DOMMatrixReadOnly(style.transform);
          oldX = matrix.m41;
          oldY = matrix.m42;
          this.resizeTop(oldX, oldY, yDiff);
          break;
        case 'resizableElementResizeHandlerTop':
          this.resizeTop(oldX, oldY, yDiff);
          break;
        case 'resizableElementResizeHandlerTopRight':
          this.resizeRight(oldX, oldY, xDiff);
          this.resizeTop(oldX, oldY, yDiff);
          break;
        case 'resizableElementResizeHandlerRight':
          this.resizeRight(oldX, oldY, xDiff);
          break;
        case 'resizableElementResizeHandlerBottomRight':
          this.resizeRight(oldX, oldY, xDiff);
          this.resizeBottom(oldX, oldY, yDiff);
          break;
        case 'resizableElementResizeHandlerBottom':
          this.resizeBottom(oldX, oldY, yDiff);
          break;
        case 'resizableElementResizeHandlerBottomLeft':
          this.resizeLeft(oldX, oldY, xDiff);
          this.resizeBottom(oldX, oldY, yDiff);
          break;
        case 'resizableElementResizeHandlerLeft':
          this.resizeLeft(oldX, oldY, xDiff);
          break;
        default:
          break;
      }

      const r = getRegionAndRect(this.container!, this.elRef.nativeElement, xDiff, yDiff);

      this.ngxResizing.emit();
      this.draggableDirective.regionChange.emit(r.region2);
    }
    this.mousePosition = { x: event.clientX, y: event.clientY };
  }

  resizeLeft(oldX: number, oldY: number, xDiff: number): void {
    if (
      !this.container! ||
      this.currentResizingHandler?.getBoundingClientRect()?.x - xDiff > this.container!.getBoundingClientRect().x
    ) {
      this.renderer2.setStyle(
        this.elRef.nativeElement,
        'width',
        this.asPxString(this.elRef.nativeElement.getBoundingClientRect().width - xDiff)
      );
      this.renderer2.setStyle(this.elRef.nativeElement, 'transform', this.asTransformString(oldX + xDiff, oldY));
    }
  }

  resizeTop(oldX: number, oldY: number, yDiff: number): void {
    if (
      !this.container! ||
      this.currentResizingHandler?.getBoundingClientRect()?.y - yDiff > this.container!.getBoundingClientRect().y
    ) {
      this.renderer2.setStyle(
        this.elRef.nativeElement,
        'height',
        this.asPxString(this.elRef.nativeElement.getBoundingClientRect().height - yDiff)
      );
      this.renderer2.setStyle(this.elRef.nativeElement, 'transform', this.asTransformString(oldX, oldY + yDiff));
    }
  }

  resizeRight(oldX: number, oldY: number, xDiff: number): void {
    const handler = this.currentResizingHandler?.getBoundingClientRect();
    if (
      !this.container! ||
      handler?.x + handler?.width / 2  + xDiff <
      this.container!.getBoundingClientRect().x + this.container!.getBoundingClientRect().width
    ) {
      this.renderer2.setStyle(
        this.elRef.nativeElement,
        'width',
        this.asPxString(this.elRef.nativeElement.getBoundingClientRect().width + xDiff)
      );
    }
  }

  resizeBottom(oldX: number, oldY: number, yDiff: number): void {
    const handler = this.currentResizingHandler?.getBoundingClientRect();
    if (
      !this.container! ||
      handler?.y + handler?.height / 2 + yDiff <
      this.container!.getBoundingClientRect().y + this.container!.getBoundingClientRect().height
    ) {
      this.renderer2.setStyle(
        this.elRef.nativeElement,
        'height',
        this.asPxString(this.elRef.nativeElement.getBoundingClientRect().height + yDiff)
      );
    }
  }

  @HostListener('window:mouseup', ['$event']) onMouseUp(ev: MouseEvent) {
    if (this.currentResizingHandler) {
      const r = getRegionAndRect(this.container!, this.elRef.nativeElement);
      this.ngxResizeEnd?.emit();
      this.draggableDirective.regionChange.emit(r.region2);
      this.currentResizingHandler = null;
      this.unFocus();
    }
  }

  asTransformString(x: number, y: number, xScale = 1, yScale = 1): string {
    return `translate(${this.asPxString(x)},${this.asPxString(y)}) scale(${xScale}, ${yScale})`;
  }

  asPxString(num: number): string {
    return num.toString().concat('px');
  }

  parsePxString(pxStr: string): number {
    const numberPattern = /\d+/g;
    pxStr ??= '';
    if (!pxStr?.includes('px')) {
      console.warn('Tried to parse non px String!');
      return NaN;
    } else {
      return Number.parseFloat(pxStr?.match(numberPattern)?.join('') ?? '');
    }
  }

  unFocus() {
    if (document.getSelection()) {
      document.getSelection()?.empty();
    } else {
      window.getSelection()?.removeAllRanges();
    }
  }
}
